module.exports = __webpack_public_path__ + "img/_logo-zc-edasneo-dark.bc234c85.webp";